'use client';

import { useMemo } from 'react';

import { api, useQuery } from '@/lib/convex';
import {
  connectHitsToLinks,
  connectMessageSearchArgs,
} from '../connect-message-links';
import type { LinkResult } from '../types';

const NO_LINKS: LinkResult[] = [];

/**
 * Connect messages and thread replies matching the command-menu term, so
 * typing part of a message at the top level of Cmd+K finds it without first
 * entering the chats scope.
 */
export function useConnectMessageSearch({
  active,
  orgSlug,
  term,
  limit,
}: {
  active: boolean;
  orgSlug?: string;
  term: string;
  limit: number;
}): { messages: LinkResult[]; isPending: boolean } {
  const args = active ? connectMessageSearchArgs(orgSlug, term) : null;
  const { data } = useQuery(
    api.organizations.channels.workspace_search.searchConnectMessages,
    args ?? 'skip'
  );
  const searching = args !== null;
  const messages = useMemo(
    () =>
      searching && data && orgSlug
        ? connectHitsToLinks(orgSlug, data.results, limit)
        : NO_LINKS,
    [searching, data, orgSlug, limit]
  );
  return { messages, isPending: searching && data === undefined };
}
